import React from "react";

import { Box } from "@chakra-ui/react";
import { ReactComponent as CheckIcon } from "assets/icons/check.svg";
import { ReactComponent as XIcon } from "assets/icons/x.svg";

import { Button } from "ui/button";

import { IBusinessSectionActionProps } from "./types";

export const BusinessSectionAction = (props: IBusinessSectionActionProps) => {
  const {
    isRejectSectionDisabled,
    handleAddRejectionReason,
    isApproveSectionDisabled,
    handleApproveSection,
    isContentWrapperBelow450,
  } = props;

  return (
    <Box
      className={`flex w-full h-full justify-end mt-10 mb-1 items-center gap-[12px] ${isContentWrapperBelow450 ? "flex-col" : ""}`}
    >
      <Button
        variant="outline"
        textColor="ep-red"
        border="1px solid #EF4444"
        _hover={{
          border: "1px solid #FFC5C5",
          bgColor: "#FEF2F2",
        }}
        icon={<XIcon />}
        className={`${isContentWrapperBelow450 ? "w-fit h-10 p-2" : "w-[181px] h-[44px]"}`}
        disabled={isRejectSectionDisabled}
        onClick={handleAddRejectionReason}
      >
        Reject Section
      </Button>
      <Button
        variant="outline"
        textColor="ep-field-green"
        border="1px solid #007928"
        _hover={{
          border: "1px solid #007928",
          bgColor: "#F7FFFB",
        }}
        icon={<CheckIcon />}
        className={`${isContentWrapperBelow450 ? "w-fit h-10 p-2" : "w-[181px] h-[44px]"}`}
        disabled={isApproveSectionDisabled}
        onClick={handleApproveSection}
      >
        Approve Section
      </Button>
    </Box>
  );
};
